import {
  makeStyles,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";
import type { Appearance } from "../data";

type BookmarkToggleButtonStyles = {
  icon: GriffelStyle;
  iconFilled: GriffelStyle;
  skeleton: GriffelStyle;
};

const defaultStyles: BookmarkToggleButtonStyles = {
  icon: {
    color: tokens.colorBrandBackground,
  },
  iconFilled: { color: tokens.colorBrandForeground1 },
  skeleton: {
    width: "160px",
  },
};

const singleColumnStyles: BookmarkToggleButtonStyles = {
  ...defaultStyles,
  icon: {
    color: tokens.colorBrandForeground1,
  },
  iconFilled: {
    color: tokens.colorBrandForeground1,
  },
  skeleton: {
    width: "140px",
  },
};

export const useInAppStyles = makeStyles(defaultStyles);
export const useCopilotLabStyles = makeStyles(defaultStyles);
export const useM365Styles = makeStyles(defaultStyles);
export const useSingleColumnStyle = makeStyles(singleColumnStyles);

export const useStyles = (appearance?: Appearance) => {
  switch (appearance) {
    case "in-app":
      return useInAppStyles;
    case "web":
      return useCopilotLabStyles;
    case "m365":
    case "bing-web":
    case "win-copilot":
      return useM365Styles;
    case "bing-mobile":
    case "underside":
    case "single-col":
      return useSingleColumnStyle;
    default:
      return useInAppStyles;
  }
};
